import type { FC } from 'react';

import type { GenericSvgIconProps } from '../CustomIcon';

/** Custom Icon with four dots for GlobalHeader on snap.com homepage */
export const DotsIcon: FC<GenericSvgIconProps> = props => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.237 14.473a3.764 3.764 0 1 0 0 7.529 3.764 3.764 0 1 0 0-7.529ZM5.765 14.473a3.764 3.764 0 1 0 0 7.529 3.764 3.764 0 1 0 0-7.529ZM18.237 2a3.764 3.764 0 1 0 0 7.529 3.764 3.764 0 1 0 0-7.529ZM5.765 2a3.765 3.765 0 0 0 0 7.529 3.765 3.765 0 0 0 0-7.529Z" />
    </svg>
  );
};
